import MainScrollWeb from "./MainScrollWeb.js";
export default MainScrollWeb;
